// extracted by mini-css-extract-plugin
export default {"faqSection":"Faq_faqSection__UL4bY","accordionList":"Faq_accordionList__EqTau","accordionItem":"Faq_accordionItem__60hk1"};